import type React from 'react';

import { BannerStateContainer } from '@confluence/banners/entry-points/BannerStateContainer.ts';
import { token } from '@atlaskit/tokens';
import { fg } from '@confluence/feature-gating';

const OBJECT_SIDEBAR_PANEL_WIDTH = 400;
const VERSION_HISTORY_SIDE_PANEL_WIDTH = 320;

const calculateIframeWidth = (isSidebarPanelOpen: boolean, isVersionHistoryOpen: boolean) => {
	if (isSidebarPanelOpen) {
		return `calc(100% - ${OBJECT_SIDEBAR_PANEL_WIDTH}px)`;
	}
	if (isVersionHistoryOpen) {
		return `calc(100% - ${VERSION_HISTORY_SIDE_PANEL_WIDTH}px)`;
	}
	return '100%';
};

export const databaseHeightContainer: (typeof BannerStateContainer)[] = [BannerStateContainer];
export const databaseShellStyle = (
	topNavAndBannerHeight: number,
	isVersionHistoryOpen: boolean = false,
	isObjectSidebarShown: boolean = false,
): React.CSSProperties => ({
	width: calculateIframeWidth(isObjectSidebarShown, isVersionHistoryOpen),
	height: topNavAndBannerHeight > 0 ? `calc(100vh - ${topNavAndBannerHeight}px)` : '100vh',
	display: 'block',
	border: fg('confluence_frontend_tokenize_border') ? token('space.0') : '0px',
	...(isVersionHistoryOpen || isObjectSidebarShown
		? { transition: 'width 300ms cubic-bezier(0.2, 0, 0, 1) 0s' }
		: {}),
});
